import { Event } from 'dashboard/models/event';
import { WebhookEvent, WebhookEventStatus } from 'dashboard/models/webhook-event';
import Action from 'lib/interfaces/Action';
import { PaginationParams } from 'lib/interfaces/api';
import { Iso8601DateString } from 'lib/types';

export type EventActions =
  | Action<EventActionType.ClearEvent>
  | Action<EventActionType.SetEvent, SetEventPayload>
  | Action<EventActionType.SetWebhookEvents, SetWebhookEventsPayload>
  | Action<EventActionType.SetFilters, FiltersPayload>
  | Action<EventActionType.SetCurrentPage, CurrentPagePayload>
  | Action<EventActionType.SetPageSize, PageSizePayload>;

export enum EventActionType {
  ClearEvent = 'event/CLEAR_EVENT',
  SetEvent = 'event/SET_EVENT',
  SetWebhookEvents = 'events/SET_WEBHOOK_EVENTS',
  SetFilters = 'events/SET_FILTERS',
  SetCurrentPage = 'events/SET_CURRENT_PAGE',
  SetPageSize = 'events/SET_PAGE_SIZE',
}

export function clearEvent(): Action<EventActionType.ClearEvent> {
  return { type: EventActionType.ClearEvent };
}

interface SetEventPayload {
  event: Event;
}

export function setEvent(event: Event): Action<EventActionType.SetEvent, SetEventPayload> {
  return {
    payload: {
      event,
    },
    type: EventActionType.SetEvent,
  };
}

interface SetWebhookEventsPayload {
  webhookEvents: WebhookEvent[];
  paginationParams: PaginationParams;
}

export interface WebhookEventsFilterParams {
  eventId?: string;
  webhookId?: string;
  status?: WebhookEventStatus[];
  updatedAtStart?: Iso8601DateString;
  updatedAtEnd?: Iso8601DateString;
  omni?: string;
}

interface FiltersPayload {
  filters: WebhookEventsFilterParams;
}

interface CurrentPagePayload {
  currentPage: number;
}

interface PageSizePayload {
  pageSize: number;
}

export function setWebhookEvents(
  webhookEvents: WebhookEvent[],
  paginationParams: PaginationParams,
): Action<EventActionType.SetWebhookEvents, SetWebhookEventsPayload> {
  return {
    payload: {
      webhookEvents,
      paginationParams,
    },
    type: EventActionType.SetWebhookEvents,
  };
}

export function setFilters(
  filters: WebhookEventsFilterParams,
): Action<EventActionType.SetFilters, FiltersPayload> {
  return {
    payload: {
      filters,
    },
    type: EventActionType.SetFilters,
  };
}

export function setCurrentPage(
  currentPage: number,
): Action<EventActionType.SetCurrentPage, CurrentPagePayload> {
  return {
    payload: {
      currentPage,
    },
    type: EventActionType.SetCurrentPage,
  };
}

export function setPageSize(
  pageSize: number,
): Action<EventActionType.SetPageSize, PageSizePayload> {
  return {
    payload: {
      pageSize,
    },
    type: EventActionType.SetPageSize,
  };
}
